<template>
  <v-row dense justify="center" align="center">
    <v-col cols="12" sm="6">
      <v-expansion-panels outlined v-model="panel_open">
        <v-expansion-panel>
          <v-expansion-panel-header>
            <template v-slot:actions>
              <v-icon color="primary"> $expand </v-icon>
            </template>
            <template v-slot:default="{ open }">
              <v-row no-gutters align="center">
                <v-col cols="8">
                  <v-row dense no-gutters align="center">
                    <v-col cols="auto">
                      <v-btn x-small icon class="mr-2" disabled>
                        <v-img
                          src="@/assets/filter.svg"
                          class="filters-icons"
                        />
                      </v-btn>
                    </v-col>
                    <v-col cols="9">
                      <strong>
                        {{ $t("messanger.dash.filters.mode.name") }}
                      </strong>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="4" class="text--secondary">
                  <v-fade-transition leave-absolute>
                    <span v-if="open" key="0">
                      {{ $t("messanger.dash.filters.mode.select_choise") }}
                    </span>
                    <span v-else key="1">
                      {{
                        $store.state.messages.sorts.conversation.filter_by
                          ? $t(
                              `messanger.dash.filters.mode.${$store.state.messages.sorts.conversation.filter_by}`
                            )
                          : ""
                      }}
                    </span>
                  </v-fade-transition>
                </v-col>
              </v-row>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-radio-group
              class="ma-0 py-0 mt-2 pt-2"
              v-model="$store.state.messages.sorts.conversation.filter_by"
              mandatory
              light
              columns
            >
              <v-row justify="center">
                <v-col cols="auto">
                  <v-radio
                    class="px-3"
                    :label="$t('messanger.dash.filters.mode.show_all')"
                    value="show_all"
                    @click="filter_conversation()"
                  ></v-radio>
                </v-col>
                <v-col cols="auto">
                  <v-radio
                    class="px-3"
                    :label="
                      $t('messanger.dash.filters.mode.show_conversations')
                    "
                    value="show_conversations"
                    @click="filter_conversation()"
                  ></v-radio>
                </v-col>
              </v-row>
            </v-radio-group>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: "filter_mode",
  data: () => {
    return {
      panel_open: false,
    };
  },
  methods: {
    filter_conversation(val) {
      console.log(this.$store.state.messages.sorts.conversation.filter_by);
      val = this.$store.state.messages.sorts.conversation.filter_by;
      this.$store.dispatch("setCloader", { showing: true });
      this.$store
        .dispatch("CONVERSATION_LENGHT")
        .then((r) => {
          this.$store
            .dispatch("filter_conversation", val)
            .then((r) => {
              this.$store.dispatch("setCloader", { showing: false });
              this.panel_open = false;
            })
            .catch((err) => {
              console.log(err);
              this.$store.dispatch("setCloader", { showing: false });
              this.panel_open = false;
            });
        })
        .catch((err) => {
          console.log(err);
          this.$store.dispatch("setCloader", { showing: false });
          this.panel_open = false;
        });
    },
  },
};
</script>
